<div class="container-fluid myColorText primary-page">
    <nav class="context-breadcrumb" aria-label="breadcrumb  rounded ">
        <ol class="breadcrumb shadow-lg">
            <li class="breadcrumb-item">
                <a routerLink="/utilisateur/admin/compte/personel">Dashboard comptes personnels</a>
            </li>
            <li class="breadcrumb-item active" aria-current="page">Informations du compte primaire</li>
        </ol>
    </nav>
    <div class="card border-0 primary-shell">
        <div class="card-header text-uppercase font-weight-bolder text-white   generalbgColorV2">
            {{firstName}} {{lastName}}
        </div>
        <div class="card-body ">
            <section class="account-panel mb-3">
                <div class="row">
                    <div class="col-sm-12 col-lg-5 mb-3 mb-lg-0">
                        <div class="card border-0 list-data-card h-100 account-info-card">
                            <div class="card-header generalbgColorV2 text-white text-center list-data-head">Information compte</div>
                            <div class="card-body list-data-body">
                                <div class="list-data-row">
                                    <span class="list-data-label">Numero compte</span>
                                    <strong class="list-data-value">
                                        {{accountNumber|slice:0:3}} {{accountNumber|slice:3:6}} {{accountNumber|slice:6:9}}
                                    </strong>
                                </div>
                                <div class="list-data-row">
                                    <span class="list-data-label">Solde</span>
                                    <strong class="list-data-value">{{accountBalance | currency:sigle}}</strong>
                                </div>
                                <div class="list-data-row">
                                    <span class="list-data-label">Telephone</span>
                                    <strong class="list-data-value">{{phone}}</strong>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12 col-lg-7">
                        <div class="card border-0 list-data-card h-100">
                            <div class="card-header generalbgColorV2 text-white text-center list-data-head">Resume activite</div>
                            <div class="card-body summary-grid">
                                <div class="summary-item">
                                    <span class="summary-value">{{ achatslist?.length || 0 }}</span>
                                    <span class="summary-label">Achats</span>
                                </div>
                                <div class="summary-item">
                                    <span class="summary-value">{{ depotslist?.length || 0 }}</span>
                                    <span class="summary-label">Depots</span>
                                </div>
                                <div class="summary-item">
                                    <span class="summary-value">{{ retraitlist?.length || 0 }}</span>
                                    <span class="summary-label">Retraits</span>
                                </div>
                                <div class="summary-item">
                                    <span class="summary-value">{{ mensuelist?.length || 0 }}</span>
                                    <span class="summary-label">Mensualites</span>
                                </div>
                                <div class="summary-item">
                                    <span class="summary-value">{{ phoneList?.length || 0 }}</span>
                                    <span class="summary-label">Telephones</span>
                                </div>
                                <div class="summary-item">
                                    <span class="summary-value">{{ idConfirm ? 'OK' : 'KO' }}</span>
                                    <span class="summary-label">Identite</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <nav class="tabs-shell">
                <div class="nav nav-tabs smart-tabs" id="nav-tab" role="tablist">
                    <button class="nav-link active myColorText font-weight-bolder smart-tab-btn" id="nav-profile-tab" type="button"
                        data-bs-toggle="tab" data-bs-target="#nav-profile" role="tab" aria-controls="nav-profile"
                        aria-selected="true" (click)="getAchats()">
                        <i class="bi bi-bag-check" aria-hidden="true"></i>
                        <span>Achats</span>
                        <span class="tab-count" *ngIf="achatslist?.length">{{ achatslist.length }}</span>
                    </button>
                    <button class="nav-link myColorText font-weight-bolder smart-tab-btn" id="nav-contact-tab" type="button"
                        data-bs-toggle="tab" data-bs-target="#nav-contact" role="tab" aria-controls="nav-contact"
                        aria-selected="false" (click)="getDepots()">
                        <i class="bi bi-box-arrow-in-down" aria-hidden="true"></i>
                        <span>Depots</span>
                        <span class="tab-count" *ngIf="depotslist?.length">{{ depotslist.length }}</span>
                    </button>
                    <button class="nav-link myColorText font-weight-bolder smart-tab-btn" id="nav-retraits-tab" type="button"
                        data-bs-toggle="tab" data-bs-target="#nav-retraits" role="tab" aria-controls="nav-retraits"
                        aria-selected="false" (click)="getRetraits()">
                        <i class="bi bi-box-arrow-up" aria-hidden="true"></i>
                        <span>Retraits</span>
                        <span class="tab-count" *ngIf="retraitlist?.length">{{ retraitlist.length }}</span>
                    </button>

                    <button class="nav-link myColorText font-weight-bolder smart-tab-btn" id="nav-mensualites-tab" type="button"
                        data-bs-toggle="tab" data-bs-target="#nav-mensualites" role="tab"
                        aria-controls="nav-mensualites" aria-selected="false"
                        (click)="getMensualites()">
                        <i class="bi bi-calendar3" aria-hidden="true"></i>
                        <span>Mensualites</span>
                        <span class="tab-count" *ngIf="mensuelist?.length">{{ mensuelist.length }}</span>
                    </button>

                    <button class="nav-link myColorText font-weight-bolder smart-tab-btn" id="nav-identification-tab" type="button"
                        data-bs-toggle="tab" data-bs-target="#nav-identification" role="tab"
                        aria-controls="nav-identification" aria-selected="false"
                        (click)="getUserInfo()">
                        <i class="bi bi-person-badge" aria-hidden="true"></i>
                        <span>Identification</span>
                    </button>
                </div>
            </nav>
            <div class="tab-content" id="nav-tabContent">
                <div class="tab-pane fade show active tab-panel" id="nav-profile" role="tabpanel" aria-labelledby="nav-profile-tab">
                    <div class="card border-0 ">
                        <div class="card-header border-0 text-center generalbgColorV2 text-white">
                            <h5 class="font-weight-bolder text-center">achats effectués</h5>
                        </div>
                        <div class="card-body">
                            <div class="row period-filter-row mb-3" *ngIf="achatslist?.length">
                                <div class="col-sm-6 col-md-3">
                                    <label class="form-label filter-label">Mois</label>
                                    <select class="form-select form-select-sm"
                                        [value]="selectedAchatsMonth ?? ''"
                                        (change)="selectedAchatsMonth = $any($event.target).value ? +$any($event.target).value : null">
                                        <option value="">Tous les mois</option>
                                        <option *ngFor="let month of monthOptions" [value]="month.value">{{ month.label }}</option>
                                    </select>
                                </div>
                                <div class="col-sm-6 col-md-3">
                                    <label class="form-label filter-label">Annee</label>
                                    <select class="form-select form-select-sm"
                                        [value]="selectedAchatsYear ?? ''"
                                        (change)="selectedAchatsYear = $any($event.target).value ? +$any($event.target).value : null">
                                        <option value="">Toutes les annees</option>
                                        <option *ngFor="let year of achatsYearOptions" [value]="year">{{ year }}</option>
                                    </select>
                                </div>
                                <div class="col-sm-12 col-md-3 d-flex align-items-end">
                                    <button type="button" class="btn btn-outline-secondary btn-sm"
                                        (click)="resetPeriodFilter('achats')">reinitialiser</button>
                                </div>
                            </div>

                            <div class="row" *ngIf="filteredAchatsList?.length; else emptyAchats">

                                <div class="col-sm-4 col-xl-3 col-lg-4 col-md-12 mb-2 border-0"
                                    *ngFor="let a of filteredAchatsList;">

                                    <div class="card border-0 list-data-card h-100">
                                        <div
                                            class="card-header border-success generalbgColorV2 text-white text-center list-data-head">
                                            {{a.date | date:"dd/MM/yyyy HH:mm:ss"}}</div>
                                        <div class="card-body list-data-body">
                                            <div class="list-data-row">
                                                <span class="list-data-label">Lieu</span>
                                                <strong class="list-data-value text-uppercase">{{a.boutique}}</strong>
                                            </div>
                                            <div class="list-data-row">
                                                <span class="list-data-label">Caissier(e)</span>
                                                <strong class="list-data-value text-uppercase">{{a.identification}}</strong>
                                            </div>
                                            <div class="list-data-row">
                                                <span class="list-data-label">Montant</span>
                                                <strong class="list-data-value">{{a.montan | currency:sigle}}</strong>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <ng-template #emptyAchats>
                                <div class="alert alert-info empty-list-message mb-0">
                                    {{ getEmptyTabMessage('achats') }}
                                </div>
                            </ng-template>
                        </div>
                    </div>
                </div>
                <div class="tab-pane fade tab-panel" id="nav-contact" role="tabpanel" aria-labelledby="nav-contact-tab">
                    <div class="card card-bg-color border-0 ">
                        <div class="card-header generalbgColorV2  text-center text-white">
                            <h5 class="font-weight-bolder text-center">depots effectués</h5>
                        </div>
                        <div class="card-body">
                            <div class="row period-filter-row mb-3" *ngIf="depotslist?.length">
                                <div class="col-sm-6 col-md-3">
                                    <label class="form-label filter-label">Mois</label>
                                    <select class="form-select form-select-sm"
                                        [value]="selectedDepotsMonth ?? ''"
                                        (change)="selectedDepotsMonth = $any($event.target).value ? +$any($event.target).value : null">
                                        <option value="">Tous les mois</option>
                                        <option *ngFor="let month of monthOptions" [value]="month.value">{{ month.label }}</option>
                                    </select>
                                </div>
                                <div class="col-sm-6 col-md-3">
                                    <label class="form-label filter-label">Annee</label>
                                    <select class="form-select form-select-sm"
                                        [value]="selectedDepotsYear ?? ''"
                                        (change)="selectedDepotsYear = $any($event.target).value ? +$any($event.target).value : null">
                                        <option value="">Toutes les annees</option>
                                        <option *ngFor="let year of depotsYearOptions" [value]="year">{{ year }}</option>
                                    </select>
                                </div>
                                <div class="col-sm-12 col-md-3 d-flex align-items-end">
                                    <button type="button" class="btn btn-outline-secondary btn-sm"
                                        (click)="resetPeriodFilter('depots')">reinitialiser</button>
                                </div>
                            </div>

                            <div class="row" *ngIf="filteredDepotsList?.length; else emptyDepots">

                                <div class="col-sm-4 col-xl-3 col-lg-4 col-md-12 mb-2 border-0"
                                    *ngFor="let d of filteredDepotsList;">

                                    <div class="card border-0 list-data-card h-100">
                                        <div class="card-header generalbgColorV2 text-center text-white list-data-head">
                                            {{d.date | date:"dd/MM/yyyy HH:mm:ss"}}</div>
                                        <div class="card-body list-data-body">
                                            <div class="list-data-row">
                                                <span class="list-data-label">Lieu</span>
                                                <strong class="list-data-value text-uppercase">{{d.boutique}}</strong>
                                            </div>
                                            <div class="list-data-row">
                                                <span class="list-data-label">Caissier(e)</span>
                                                <strong class="list-data-value text-uppercase">{{d.identification}}</strong>
                                            </div>
                                            <div class="list-data-row">
                                                <span class="list-data-label">Montant</span>
                                                <strong class="list-data-value">{{d.amount | currency:sigle}}</strong>
                                            </div>
                                            <div class="list-data-row">
                                                <span class="list-data-label">Frais</span>
                                                <strong class="list-data-value">{{d.retenu | currency:sigle}}</strong>
                                            </div>
                                            <div class="list-data-row">
                                                <span class="list-data-label">Sur compte</span>
                                                <strong class="list-data-value">{{d.depot | currency:sigle}}</strong>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <ng-template #emptyDepots>
                                <div class="alert alert-info empty-list-message mb-0">
                                    {{ getEmptyTabMessage('depots') }}
                                </div>
                            </ng-template>
                        </div>
                    </div>
                </div>
                <div class="tab-pane fade tab-panel" id="nav-retraits" role="tabpanel" aria-labelledby="nav-retraits-tab">
                    <div class="card card-bg-color border-0 ">
                        <div class="card-header text-center generalbgColorV2">
                            <h5 class="font-weight-bolder text-center text-white">retraits effectués</h5>
                        </div>
                        <div class="card-body">
                            <div class="row period-filter-row mb-3" *ngIf="retraitlist?.length">
                                <div class="col-sm-6 col-md-3">
                                    <label class="form-label filter-label">Mois</label>
                                    <select class="form-select form-select-sm"
                                        [value]="selectedRetraitsMonth ?? ''"
                                        (change)="selectedRetraitsMonth = $any($event.target).value ? +$any($event.target).value : null">
                                        <option value="">Tous les mois</option>
                                        <option *ngFor="let month of monthOptions" [value]="month.value">{{ month.label }}</option>
                                    </select>
                                </div>
                                <div class="col-sm-6 col-md-3">
                                    <label class="form-label filter-label">Annee</label>
                                    <select class="form-select form-select-sm"
                                        [value]="selectedRetraitsYear ?? ''"
                                        (change)="selectedRetraitsYear = $any($event.target).value ? +$any($event.target).value : null">
                                        <option value="">Toutes les annees</option>
                                        <option *ngFor="let year of retraitsYearOptions" [value]="year">{{ year }}</option>
                                    </select>
                                </div>
                                <div class="col-sm-12 col-md-3 d-flex align-items-end">
                                    <button type="button" class="btn btn-outline-secondary btn-sm"
                                        (click)="resetPeriodFilter('retraits')">reinitialiser</button>
                                </div>
                            </div>

                            <div class="row" *ngIf="filteredRetraitsList?.length; else emptyRetraits">

                                <div class="col-sm-4 col-xl-3 col-lg-4 col-md-12 mb-2 " *ngFor="let r of filteredRetraitsList;">

                                    <div class="card list-data-card h-100">
                                        <div class="card-header generalbgColorV2 text-center text-white list-data-head">
                                            {{r.date | date:"dd/MM/yyyy HH:mm:ss"}}</div>
                                        <div class="card-body list-data-body">
                                            <div class="list-data-row">
                                                <span class="list-data-label">Lieu</span>
                                                <strong class="list-data-value text-uppercase">{{r.boutique}}</strong>
                                            </div>
                                            <div class="list-data-row">
                                                <span class="list-data-label">Caissier(e)</span>
                                                <strong class="list-data-value text-uppercase">{{r.identification}}</strong>
                                            </div>
                                            <div class="list-data-row">
                                                <span class="list-data-label">Voulu</span>
                                                <strong class="list-data-value">{{r.amount | currency:sigle}}</strong>
                                            </div>
                                            <div class="list-data-row">
                                                <span class="list-data-label">Frais</span>
                                                <strong class="list-data-value">{{r.retenu | currency:sigle}}</strong>
                                            </div>
                                            <div class="list-data-row">
                                                <span class="list-data-label">Total</span>
                                                <strong class="list-data-value list-data-total">{{r.retrait | currency:sigle}}</strong>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <ng-template #emptyRetraits>
                                <div class="alert alert-info empty-list-message mb-0">
                                    {{ getEmptyTabMessage('retraits') }}
                                </div>
                            </ng-template>
                        </div>
                    </div>
                </div>

                <div class="tab-pane fade tab-panel" id="nav-mensualites" role="tabpanel"
                    aria-labelledby="nav-mensualites-tab">
                    <div class="card card-bg-color">
                        <div class="card-header  text-center  generalbgColorV2">
                            <h5 class="font-weight-bolder  text-white ">rapport mensuel</h5>
                        </div>
                        <div class="card-body">
                            <div class="row period-filter-row mb-3" *ngIf="mensuelist?.length">
                                <div class="col-sm-6 col-md-3">
                                    <label class="form-label filter-label">Mois</label>
                                    <select class="form-select form-select-sm"
                                        [value]="selectedMensualitesMonth ?? ''"
                                        (change)="selectedMensualitesMonth = $any($event.target).value ? +$any($event.target).value : null">
                                        <option value="">Tous les mois</option>
                                        <option *ngFor="let month of monthOptions" [value]="month.value">{{ month.label }}</option>
                                    </select>
                                </div>
                                <div class="col-sm-6 col-md-3">
                                    <label class="form-label filter-label">Annee</label>
                                    <select class="form-select form-select-sm"
                                        [value]="selectedMensualitesYear ?? ''"
                                        (change)="selectedMensualitesYear = $any($event.target).value ? +$any($event.target).value : null">
                                        <option value="">Toutes les annees</option>
                                        <option *ngFor="let year of mensualitesYearOptions" [value]="year">{{ year }}</option>
                                    </select>
                                </div>
                                <div class="col-sm-12 col-md-3 d-flex align-items-end">
                                    <button type="button" class="btn btn-outline-secondary btn-sm"
                                        (click)="resetPeriodFilter('mensualites')">reinitialiser</button>
                                </div>
                            </div>

                            <div class="row" *ngIf="filteredMensualitesList?.length; else emptyMensualites">

                                <div class="col-sm-4 col-xl-3 col-lg-4 col-md-12 mb-2 border-0"
                                    *ngFor="let m of filteredMensualitesList;">

                                    <div class="card border-0 list-data-card h-100">
                                        <div class="card-header generalbgColorV2 text-white text-center list-data-head">
                                            {{m.month}}/{{m.annee}}</div>
                                        <div class="card-body list-data-body">
                                            <div class="list-data-row">
                                                <span class="list-data-label">Total depot</span>
                                                <strong class="list-data-value">{{m.depot | currency:sigle}}</strong>
                                            </div>
                                            <div class="list-data-row">
                                                <span class="list-data-label">Total retrait</span>
                                                <strong class="list-data-value">{{m.retrait | currency:sigle}}</strong>
                                            </div>
                                            <div class="list-data-row">
                                                <span class="list-data-label">Total transfert</span>
                                                <strong class="list-data-value">{{m.transfert | currency:sigle}}</strong>
                                            </div>
                                            <div class="list-data-row">
                                                <span class="list-data-label">Total achats</span>
                                                <strong class="list-data-value list-data-total">{{m.achat | currency:sigle}}</strong>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <ng-template #emptyMensualites>
                                <div class="alert alert-info empty-list-message mb-0">
                                    {{ getEmptyTabMessage('mensualites') }}
                                </div>
                            </ng-template>
                        </div>
                    </div>
                </div>


                <div class="tab-pane fade tab-panel" id="nav-identification" role="tabpanel"
                    aria-labelledby="nav-identification-tab">
                    <div class="card card-bg-color ">
                        <div class="card-header  text-center generalbgColorV2">
                            <h5 class="font-weight-bolder text-center text-white">Identification</h5>
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-sm-8 mb-2">

                                    <div class="card">
                                        <div class="card-body table-responsive">
                                            <h5 class="card-title"><strong>{{qSecret}}?</strong> <em>{{rSecret}}</em>
                                            </h5>

                                            <h5 class="card-title">code secret: <em>{{secretPin}}</em></h5>
                                            <h5 class="card-title">code de contrainte: <em>{{contrainPin}}</em></h5>
                                            <h5>Nom : <em>{{firstName }}</em></h5>
                                            <h5>Prénom:<em>{{lastName}}</em></h5>
                                            <h5 *ngIf="isenvoyer" class="text-success font-weight-bolder">Email
                                                envoye </h5>
                                            <table class="table table-striped table-borderless table-sm">

                                                <tbody>
                                                    <tr>
                                                        <th scope="row">absence de CNI</th>
                                                        <td> <button type="button" class="btn btn-outline-primary"
                                                                (click)="emailAlert(4)">envoyer email</button></td>

                                                    </tr>
                                                    <tr>
                                                        <th scope="row">information ne correspondent pas</th>
                                                        <td> <button type="button" class="btn btn-outline-secondary"
                                                                (click)="emailAlert(1)">envoyer email</button>
                                                        </td>

                                                    </tr>
                                                    <tr>
                                                        <th scope="row">il maque l'autre face de la CNI</th>
                                                        <td><button type="button" class="btn btn-outline-secondary"
                                                                (click)="emailAlert(2)">envoyer email</button>
                                                        </td>

                                                    </tr>
                                                    <tr>
                                                        <th scope="row">l'utilisateur est mineur</th>
                                                        <td><button type="button" class="btn btn-outline-secondary"
                                                                (click)="emailAlert(3)">envoyer email</button>
                                                        </td>

                                                    </tr>
                                                </tbody>
                                            </table>


                                            <!--<button type="button" class="btn btn-outline-secondary">Secondary</button>
                                            <button type="button" class="btn btn-outline-success">Success</button>
                                            <button type="button" class="btn btn-outline-danger">Danger</button>
                                            <button type="button" class="btn btn-outline-warning">Warning</button>
                                            <button type="button" class="btn btn-outline-info">Info</button>
                                            <button type="button" class="btn btn-outline-light">Light</button>
                                            <button type="button" class="btn btn-outline-dark">Dark</button>-->

                                        </div>


                                    </div>
                                </div>
                                <div class="col-sm-4 mb-2">
                                    <div class="card border-0 shadow-sm">
                                        <div class="card-body">
                                            <h5 class="card-title">Numero de Telephone</h5>
                                            <small class="text-muted">Validation SMS suspendue: verification admin
                                                uniquement.</small>
                                            <table class="table">
                                                <tr *ngFor="let p of phoneList;">
                                                    <th scope="row">{{p.phone}}</th>
                                                    <td>
                                                        <div *ngIf="p.principal else notPrincipal">
                                                            <i class="bi bi-check-circle" style="color: green;"></i>
                                                        </div>
                                                        <ng-template #notPrincipal>
                                                            <i class="bi bi-file-x" style="color: red;"></i>
                                                        </ng-template>

                                                    </td>
                                                    <td>
                                                        <div *ngIf="p.confirm else notConfirm">
                                                            <i class="bi bi-check-circle" style="color:green"></i>
                                                        </div>
                                                        <ng-template #notConfirm>
                                                            <span class="badge badge-secondary">validation SMS
                                                                suspendue</span>
                                                        </ng-template>
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>

                                    <div class="card border-0 shadow-sm mt-2 identity-card">
                                        <div class="card-body">
                                            <h5 class="card-title mb-3">Photo de profil</h5>
                                            <div *ngIf="urlProfile; else noProfilePhoto" class="profile-photo-wrapper">
                                                <img [src]="urlProfile" alt="Photo de profil" class="profile-photo">
                                                <a class="btn btn-sm btn-outline-primary mt-2" [href]="urlProfile"
                                                    target="_blank" rel="noopener">Voir en grand</a>
                                            </div>
                                            <ng-template #noProfilePhoto>
                                                <div class="identity-empty">Aucune photo de profil disponible.</div>
                                            </ng-template>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-8 mb-2">
                                    <div class="card border-0 shadow-sm identity-card">
                                        <div class="card-body">
                                            <h5 class="card-title mb-3">Pieces d'identite</h5>
                                            <div class="identity-grid">
                                                <div class="identity-item">
                                                    <div class="identity-label">CNI - Recto</div>
                                                    <div *ngIf="urlRecto; else emptyRecto" class="identity-media">
                                                        <img [src]="urlRecto" alt="CNI recto" class="identity-image">
                                                        <a class="btn btn-sm btn-outline-primary mt-2" [href]="urlRecto"
                                                            target="_blank" rel="noopener">Ouvrir</a>
                                                    </div>
                                                    <ng-template #emptyRecto>
                                                        <div class="identity-empty">Document non fourni.</div>
                                                    </ng-template>
                                                </div>

                                                <div class="identity-item">
                                                    <div class="identity-label">CNI - Verso</div>
                                                    <div *ngIf="urlVerso; else emptyVerso" class="identity-media">
                                                        <img [src]="urlVerso" alt="CNI verso" class="identity-image">
                                                        <a class="btn btn-sm btn-outline-primary mt-2" [href]="urlVerso"
                                                            target="_blank" rel="noopener">Ouvrir</a>
                                                    </div>
                                                    <ng-template #emptyVerso>
                                                        <div class="identity-empty">Document non fourni.</div>
                                                    </ng-template>
                                                </div>

                                                <div class="identity-item">
                                                    <div class="identity-label">Autorisation parentale - Recto</div>
                                                    <div *ngIf="urlRectoMineur; else emptyRectoMineur"
                                                        class="identity-media">
                                                        <img [src]="urlRectoMineur" alt="Autorisation parentale recto"
                                                            class="identity-image">
                                                        <a class="btn btn-sm btn-outline-primary mt-2"
                                                            [href]="urlRectoMineur" target="_blank"
                                                            rel="noopener">Ouvrir</a>
                                                    </div>
                                                    <ng-template #emptyRectoMineur>
                                                        <div class="identity-empty">Document non fourni.</div>
                                                    </ng-template>
                                                </div>

                                                <div class="identity-item">
                                                    <div class="identity-label">Autorisation parentale - Verso</div>
                                                    <div *ngIf="urlVersoMineur; else emptyVersoMineur"
                                                        class="identity-media">
                                                        <img [src]="urlVersoMineur" alt="Autorisation parentale verso"
                                                            class="identity-image">
                                                        <a class="btn btn-sm btn-outline-primary mt-2"
                                                            [href]="urlVersoMineur" target="_blank"
                                                            rel="noopener">Ouvrir</a>
                                                    </div>
                                                    <ng-template #emptyVersoMineur>
                                                        <div class="identity-empty">Document non fourni.</div>
                                                    </ng-template>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!--https://immo.cm/softpay-image.africa/890370053/5081392f-67a9-4dc6-a66d-3439863fb5b4.webp-->
                                <div class="col-sm-4 mb-2">
                                    <div class="card">
                                        <div class="card-body">

                                            <div *ngIf="idConfirm else notConfirm">
                                                <h4 class="text-success"> ce compte est deja activé</h4>
                                                <button type="button" class="btn btn-danger" id="activationCompte"
                                                    (click)="desactivationCompte()">
                                                    desactivation
                                                </button>
                                            </div>
                                            <ng-template #notConfirm>
                                                <h5 class="card-title">activé le compte de cet utilisateur si son
                                                    identité est confirmé</h5>
                                                <button *ngIf="!idConfirm;else " type="button" class="btn btn-success"
                                                    id="activationCompte" (click)="ActivationCompte()">
                                                    activation
                                                </button>
                                            </ng-template>
                                        </div>
                                    </div>
                                    <p *ngIf="isActif" class="text-success font-weight-bolder">Ce compte est désormais
                                        actif.</p>
                                    <p *ngIf="echeck" class="text-danger font-weight-bolder">L'email n'a pas ete envoye.
                                    </p>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>
